import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'

export interface UpdateVehicleSettingsPayload {
  customImage?: File | string | null
  customName?: string
}

/**
 * Update vehicle settings (custom name and/or custom image)
 */
export const updateVehicleSettings = async (
  installationId: number,
  vehicleId: number,
  payload: UpdateVehicleSettingsPayload,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    const formData = new FormData()

    if (payload.customName !== undefined && payload.customName !== null) {
      formData.append('customName', payload.customName)
    }
    if (payload.customImage instanceof File) {
      formData.append('customImage', payload.customImage)
    } else if (payload.customImage === '') {
      formData.append('customImage', '')
    }

    const response = await authFetch<unknown>({
      path: `vehicles/installations/${installationId}/vehicles/${vehicleId}`,
      method: 'PUT',
      payload: formData,
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
    })

    if (response.status === StatusCodes.OK || response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<boolean, Error | AuthFetchError>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
